import React from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid'
import moment from 'moment'

import SelectField from 'components/Common/SelectField'
import { CalendarField } from 'components/Calendar/style'
import { calendarOptions } from 'config'

const Toolbar = ({ view, setDate, date, setView, ...toolbar }) => {
  const goToBack = () => {
    let newDate: any = ''
    if (view === 'month') {
      newDate = moment(date).subtract(1, 'months').startOf('month')
    } else if (view === 'week') {
      newDate = moment(date).subtract(1, 'week')
    } else if (view === 'day') {
      newDate = moment(date).subtract(1, 'days')
    }
    setDate(newDate)
    toolbar.onNavigate('PREV')
  }
  const goToNext = () => {
    let newDate: any = ''
    if (view === 'month') {
      newDate = moment(date).add(1, 'months').startOf('month')
    } else if (view === 'week') {
      newDate = moment(date).add(1, 'week')
    } else if (view === 'day') {
      newDate = moment(date).add(1, 'days')
    }
    setDate(newDate)
    toolbar.onNavigate('NEXT')
  }

  const handleViewChange = (view) => {
    setView(view)
    toolbar.onView(view)
  }

  return (
    <div className="flex flex-col-reverse sm:flex-row justify-between items-center mb-5">
      <div className="flex justify-center sm:justify-start items-center grow gap-3 mt-5 sm:mt-0">
        <ChevronLeftIcon
          className="fill-primary w-[45px] h-[45px] cursor-pointer"
          onClick={() => goToBack()}
        />
        <div className="text-primary-text text-2xl font-normal leading-7 font-primary">
          {toolbar.label}
        </div>
        <ChevronRightIcon
          className="fill-primary w-[45px] h-[45px] cursor-pointer"
          onClick={() => goToNext()}
        />
      </div>
      <CalendarField>
        <SelectField
          placeholder="Select"
          value={view}
          name="calendarView"
          options={calendarOptions}
          onChange={handleViewChange}
        />
      </CalendarField>
    </div>
  )
}

export default Toolbar
